module.exports = __webpack_public_path__ + "static/img/finish.c338317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/finish.png
// module id = R3Su
// module chunks = 1